module.exports = __webpack_public_path__ + "img/collection-engagementRingsFancy.f91460d.webp";